module.exports = __webpack_public_path__ + "static/media/Git.686efd58.bin";